// React
import React from "react";
// React
// models
import { I_QuizMakerQuestions } from "../Models/interfaces";
// models

export const SetUserQuestionContext = React.createContext<React.Dispatch<
  React.SetStateAction<I_QuizMakerQuestions[]>
  > | null>(null);
